module.exports = __webpack_public_path__ + "static/media/mimi.9010f2b1.png";